module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.contact != null) ? _c('ul', {
    staticClass: "contact-info upper"
  }, [(_vm.contact.address != null) ? _c('li', [_c('span', [_c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.address",
      modifiers: {
        "address": true
      }
    }],
    staticStyle: {
      "display": "inline"
    }
  }), _vm._v(":")]), _vm._v(" " + _vm._s(_vm.contact.address) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.contact.email != null) ? _c('li', [_c('span', [_c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.email",
      modifiers: {
        "email": true
      }
    }],
    staticStyle: {
      "display": "inline"
    }
  }), _vm._v(":")]), _vm._v(" " + _vm._s(_vm.contact.email) + ". " + _vm._s(_vm.contact.city) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.contact.webpage) ? _c('li', [_c('span', [_c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.web",
      modifiers: {
        "web": true
      }
    }],
    staticStyle: {
      "display": "inline"
    }
  }), _vm._v(":")]), _vm._v(" " + _vm._s(_vm.contact.webpage) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.contact.phone) ? _c('li', [_c('span', [_c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.phone",
      modifiers: {
        "phone": true
      }
    }],
    staticStyle: {
      "display": "inline"
    }
  }), _vm._v(":")]), _vm._v(" " + _vm._s(_vm.contact.phone) + "\n    ")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f9d5e28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/contact/contactInfo.vue
// module id = 366
// module chunks = 0